const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/eCheckin/sections/components/metakat/Versicherung/InsuranceInformation.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mMetaKatDropDown } from '@cistec/common_web/modules/CIS4m/components/CIS4mMetaKatDropDown';
import { useCIS4FormMetaKatData } from 'App/store/cis4m';
import { TextInput } from '@cistec/common_web/utils/intlUtils';
import { useIntl } from 'react-intl';

interface Props {
    label: TextInput;
    path: string;
    hidden?: boolean;
    required?: boolean;
}

export const InsuranceInformationField = forwardRef((props: Props, ref: any) => {
    const dropdownRef = useCIS4m(ref);
    const { locale } = useIntl();

    const hidden = props.hidden ?? false;
    const required = props.required ?? false;

    return (
        <CIS4mMetaKatDropDown
            ref={dropdownRef}
            label={props.label}
            path={props.path}
            pcode={'637a0b33-487f-46aa-9ed1-cc2505924913'}
            valuePath="FKEY"
            labelPath={`CONTENT.Lang.${locale}`}
            hidden={hidden}
            required={required}
            dataHook={useCIS4FormMetaKatData}
        />
    );
});

InsuranceInformationField.displayName = 'InsuranceInformationField';
